export const FETCH_PURITY_CONFIGURATION_REQUEST = 'FETCH_PURITY_CONFIGURATION_REQUEST';
export const FETCH_PURITY_CONFIGURATION_SUCCESS = 'FETCH_PURITY_CONFIGURATION_SUCCESS';
export const FETCH_PURITY_CONFIGURATION_FAILURE = 'FETCH_PURITY_CONFIGURATION_FAILURE';

export const ADD_PURITY_CONFIGURATION_REQUEST = 'ADD_PURITY_CONFIGURATION_REQUEST';
export const ADD_PURITY_CONFIGURATION_SUCCESS = 'ADD_PURITY_CONFIGURATION_SUCCESS';
export const ADD_PURITY_CONFIGURATION_FAILURE = 'ADD_PURITY_CONFIGURATION_FAILURE';

export const UPDATE_PURITY_CONFIGURATION_REQUEST = 'UPDATE_PURITY_CONFIGURATION_REQUEST';
export const UPDATE_PURITY_CONFIGURATION_SUCCESS = 'UPDATE_PURITY_CONFIGURATION_SUCCESS';
export const UPDATE_PURITY_CONFIGURATION_FAILURE = 'UPDATE_PURITY_CONFIGURATION_FAILURE';

export const DELETE_PURITY_CONFIGURATION_REQUEST = 'DELETE_PURITY_CONFIGURATION_REQUEST';
export const DELETE_PURITY_CONFIGURATION_SUCCESS = 'DELETE_PURITY_CONFIGURATION_SUCCESS';
export const DELETE_PURITY_CONFIGURATION_FAILURE = 'DELETE_PURITY_CONFIGURATION_FAILURE';

export const PURITY_CONFIGURATION_FORM_ERROR = 'PURITY_CONFIGURATION_FORM_ERROR';
export const PURITY_CONFIGURATION_FORM_SUCCESS = 'PURITY_CONFIGURATION_FORM_SUCCESS';
export const SET_PURITY_CONFIGURATION_EDIT = 'SET_PURITY_CONFIGURATION_EDIT';
export const CLEAR_PURITY_CONFIGURATION_EDIT = 'CLEAR_PURITY_CONFIGURATION_EDIT'; 